import { DEFAULT_CONFIG } from './constants.js';
import 'ricos-schema';
import './types.js';

const DEFAULT_PALETTE = ["#FFFFFF", "#D5D4D4", "#000000", "#ABCAFF", "#81B0FF", "#0261FF"];
const DEFAULTS = {
  config: DEFAULT_CONFIG,
  button: {
    settings: {
      buttonText: "Click Me"
    },
    design: {
      borderRadius: 0,
      borderWidth: 0
    }
  }
};

export { DEFAULTS, DEFAULT_PALETTE };
//# sourceMappingURL=defaults.js.map
